import CloudDownload from "@material-ui/icons/CloudDownload";
import Cached from "@material-ui/icons/Cached";
import Warning from "@material-ui/icons/Warning";
import Cancel from "@material-ui/icons/Cancel";
import Schedule from "@material-ui/icons/Schedule";
import CircularProgress from "@material-ui/core/CircularProgress";

export default status => {
  switch (status) {
    case "ready":
    case "published":
      return CloudDownload;
    case "error":
      return Warning;
    case "canceled":
      return Cancel;
    case "pending":
      return Schedule;
    case "refresh":
      return Cached;
    case "processing":
    case "preparing":
    case "generating_metadata":
    case "process_queued":
    case "new":
      return CircularProgress;
    default:
      return null;
  }
};
